import { Grid } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { projectStatusViewValue } from '../../../functions/convert-to-view-value/project-status-view-value';
import { ProjectStatus } from '../../../types/enum/project-status';
import { MuiInput, MuiSelect } from '../../shared/form-element';

const vt = viewTexts.pages.projectList.searchBar;

const Root = styled.div`
  padding-left: 10px;
`;

const FilterStatusSelectWrapper = styled.div`
  width: 120px;
`;

const FilterAuthorSelectWrapper = styled.div`
  width: 200px;
`;

const FilterApproverSelectWrapper = styled.div`
  width: 200px;
`;

const projectStatusSelectOptions = (['approved', 'unapproved'] as const).map(
  a => ({
    id: a,
    label: projectStatusViewValue(a)
  })
);

interface Props {
  name: string;
  onInput: (value: string) => void;
  status: ProjectStatus | undefined;
  onStatusChange: (value: ProjectStatus | undefined) => void;
  author: string | undefined;
  authorOptions: { id: string; label: string }[];
  onAuthorChange: (value: string | undefined) => void;
  approver: string | undefined;
  approverOptions: { id: string; label: string }[];
  onApproverChange: (value: string | undefined) => void;
}

const noop = () => undefined;

export const ProjectSearchBar = memo(
  ({
    name,
    onInput = noop,
    status,
    onStatusChange,
    author,
    authorOptions,
    onAuthorChange,
    approver,
    approverOptions,
    onApproverChange
  }: Props) => {
    const onStatusChange_ = useCallback(
      (value: string | undefined) => {
        onStatusChange(value as ProjectStatus | undefined);
      },
      [onStatusChange]
    );

    return (
      <Root>
        <Grid container spacing={1} alignItems='flex-end'>
          <Grid item>
            <SearchIcon />
          </Grid>
          <Grid item>
            <MuiInput label={vt.name} value={name} onInput={onInput} />
          </Grid>
          <Grid item>
            <FilterStatusSelectWrapper>
              <MuiSelect
                selectedId={status}
                options={projectStatusSelectOptions}
                onChange={onStatusChange_}
                useEmptyLabel={true}
                label={vt.status}
              />
            </FilterStatusSelectWrapper>
          </Grid>
          <Grid item>
            <FilterAuthorSelectWrapper>
              <MuiSelect
                selectedId={author}
                options={authorOptions}
                onChange={onAuthorChange}
                useEmptyLabel={true}
                label={vt.author}
              />
            </FilterAuthorSelectWrapper>
          </Grid>
          <Grid item>
            <FilterApproverSelectWrapper>
              <MuiSelect
                selectedId={approver}
                options={approverOptions}
                onChange={onApproverChange}
                useEmptyLabel={true}
                label={vt.approver}
              />
            </FilterApproverSelectWrapper>
          </Grid>
        </Grid>
      </Root>
    );
  }
);

ProjectSearchBar.displayName = 'ProjectSearchBar';
